import { ClientError } from '@ricoh/ria.client.core/errors';
import { createPrepareError } from '@ricoh/ria.client.core/plugins/swr/common';

import type { SaveBatchRequestData } from './_request.type';

/** SaveBatch PrepareError. */
export const saveBatchPrepareError = createPrepareError<SaveBatchRequestData>((requestData) => ({
  BatchFieldNotExist: (error) => {
    const [id] = error.values ?? [];
    if (!id || typeof id !== 'string') {
      throw new ClientError({
        module: 'service',
        message: 'Invalid batch field id',
        cause: { error },
      });
    }

    const field = requestData.fields[id];
    return field
      ? {
          ...error,
          code: 'batchFieldNotFound_field',
          values: [field.displayName ?? field.name],
        }
      : {
          ...error,
          code: 'batchFieldNotFound',
          values: [],
        };
  },

  DocumentFieldNotExist: (error) => {
    const [id] = error.values ?? [];
    if (!id || typeof id !== 'string') {
      throw new ClientError({
        module: 'service',
        message: 'Invalid batch document id',
        cause: { error },
      });
    }

    const field = Object.values(requestData.documents).find((document) => !!document.fields?.[id])?.fields?.[id];
    return field
      ? {
          ...error,
          code: 'documentFieldNotFound_field',
          values: [field.displayName ?? field.name],
        }
      : {
          ...error,
          code: 'documentFieldNotFound',
          values: [],
        };
  },
}));
